<template>
    <modal v-model="isActive"
           persistent
           :loading="isLoading"
           v-bind="modalOptions" @cancel="handleCancel">

        <template #title>
            <slot name="title"/>
        </template>

        <ajax-form v-bind="formOptions"
                   :id="formId"
                   ref="form"
				   class="stretch-layout"
                   v-model:loading="isLoading"
                   @success="handleSuccess"
                   @error="handleError">

            <slot/>

        </ajax-form>

		<template v-if="$slots.footer || !hideSubmit" #button>
			<slot name="footer"/>

			<btn v-if="!hideSubmit" :form="formId" type="submit" :color="submitColor" :loading="isLoading" :disabled="isLoading">
				<Icon :icon="submitIcon ? submitIcon : icons.submit"/>
				<span v-if="submitButtonText">{{ submitButtonText }}</span>
			</btn>
		</template>

    </modal>
</template>

<script>
import Toggleable from "../../mixins/Toggleable";
	import {mdiCheck} from "@mdi/js";
	import {submitIcon} from "../../config";

    export default {
        name: 'AjaxFormModal',

        mixins: [Toggleable],

		emits: ['success', 'error', 'cancel'],

        props: {

            // The options to pass to the modal component
            modalOptions: {
                type: Object,
                default: () => {
                    return {}
                }
            },

            // The options to pass to the form component
            formOptions: {
                type: Object,
                required: true
            },

            submitIcon: {
                type: String,
                default: null
            },

            submitColor: {
                type: String,
                default: 'success'
            },

            submitText: {
                type: String,
                default: null
            },

            hideSubmit: {
                type: Boolean,
                default: false
            },

            // Whether the modal shall stay open after submit
            activeAfterSubmit: {
                type: Boolean,
                default: false
            }

        },

        data() {
            return {
                isLoading: false,
                formId: 'ajax_form_' + Math.floor(Math.random() * 99999),
				icons: {
					submit: submitIcon,

				}
            }
        },

        computed: {
            submitButtonText() {
                if (this.submitText) {
                    return this.submitText;
                }

                return this.$t('action.save');
            }
        },

        methods: {
            handleSuccess(data, response) {
                this.isLoading = false
                this.isActive = this.activeAfterSubmit;

                this.$emit('success', data, response)
            },

            handleError(data) {
                this.isLoading = false
                this.$emit('error', data)
            },

            handleCancel() {
              this.$emit('cancel');
            },

			// TODO: Expose when migrated to composition API
            validationSubmit() {
                if (this.$refs.form) {
                    try {
						this.$refs.form.validationSubmit();
					} catch (e) {
						console.error(e)
					}
                }
            }
        }
    }
</script>